import {
  SET,
  ADD,
  UPDATE,
  DELETE,
  CREATE,
  COMPLETE,
  LOADING,
} from './mutation-types';

export default {
  [SET](state, payload) {
    state.items = payload;
  },
  [ADD](state, payload) {
    state.items = [...state.items, payload];
  },
  [UPDATE](state, payload) {
    state.items = state.items.map(key => (key.id === payload.id ? Object.assign({}, key, payload) : key));
  },
  [DELETE](state, payload) {
    state.items = state.items.filter(item => item.id !== payload);
  },
  [CREATE](state, payload) {
    state.newKey = payload;
  },
  [COMPLETE](state) {
    state.newKey = null;
  },
  [LOADING](state, payload) {
    state.loading = payload;
  },
};
